import type { SVGProps } from 'react';
const SvgPlace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M5.734 5.734a2.266 2.266 0 1 0 4.532 0 2.266 2.266 0 0 0-4.532 0"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
    <path
      d="M8 1.203a4.53 4.53 0 0 1 4.531 4.531c0 2.059-3.065 7.22-4.153 8.86a.454.454 0 0 1-.756 0c-1.088-1.64-4.153-6.801-4.153-8.86A4.53 4.53 0 0 1 8 1.204"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgPlace;
